import classNames from 'classnames';
import React from 'react';
import styles from './SelectEntityOption.module.scss';

export interface SelectEntityOptionProps {
  disabled?: boolean;
  icon?: React.ReactNode;
  label: React.ReactNode;
  onClick?: (e: React.SyntheticEvent) => void;
  rightMeta?: React.ReactNode;
  secondary?: React.ReactNode;
  secondaryTop?: React.ReactNode;
}

const SelectEntityOption = React.forwardRef<
  HTMLDivElement,
  SelectEntityOptionProps
>(
  (
    {
      disabled = false,
      icon = null,
      label = null,
      secondary = null,
      secondaryTop = null,
      rightMeta = null,
      onClick,
    }: SelectEntityOptionProps,
    ref,
  ) => (
    // eslint-disable-next-line jsx-a11y/no-static-element-interactions -- TODO - fix next time this file is edited
    <div
      className={classNames(styles.container, {
        [styles.disabled]: disabled,
      })}
      ref={ref}
      tabIndex={-1}
      onClick={onClick}
    >
      {!!icon && <div className={styles.icon}>{icon}</div>}
      <div className={styles.info}>
        {!!secondaryTop && (
          <div className={styles.secondary}>{secondaryTop}</div>
        )}
        <div className={styles.label}>{label}</div>
        {!!secondary && <div className={styles.secondary}>{secondary}</div>}
      </div>
      {!!rightMeta && <div className={styles.rightMeta}>{rightMeta}</div>}
    </div>
  ),
);

export default SelectEntityOption;
